'use strict'
//a stream that ends immediately.
module.exports = function empty () {
  return function (abort, cb) {
    cb(true)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/sources/empty.js
// module id = 778
// module chunks = 0